import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const ShoprenterAbandonedOrder: WorkflowActivityDefinition = {
  group: 'shoprenter',
  name: 'shoprenter-abandoned-order',
  type: 'trigger',
  schema: {
    type: 'object',
  },
  outputs: [
    {
      name: 'outFlow',
      type: 'flowControl',
    },
    {
      name: 'order',
      type: 'order',
    },
  ],
};

registerActivity(ShoprenterAbandonedOrder);
